'use strict';

Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: 'Module' } });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const IconButton_IconButton = require('../IconButton/IconButton.cjs.js');
const ModalDialog_Body = require('./Body.cjs.js');
const ModalDialog_Footer = require('./Footer.cjs.js');
const ModalDialog_Header = require('./Header.cjs.js');
const ModalDialog_Trigger = require('./Trigger.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const modalOverlay = "_modal-overlay_1sat7_17";
const fadeIn = "_fade-in_1sat7_1";
const fadeOut = "_fade-out_1sat7_1";
const modal = "_modal_1sat7_17";
const dialog = "_dialog_1sat7_57";
const closeButton = "_close-button_1sat7_71";
const styles = {
	modalOverlay: modalOverlay,
	fadeIn: fadeIn,
	fadeOut: fadeOut,
	modal: modal,
	dialog: dialog,
	closeButton: closeButton
};

const ModalDialogRoot = (_a) => {
  var { children, className, isDismissable = true, isOpen, onOpenChange } = _a, props = tslib_es6.__rest(_a, ["children", "className", "isDismissable", "isOpen", "onOpenChange"]);
  const contextValue = React__default.default.useMemo(() => ({ isDismissable }), [isDismissable]);
  return React__default.default.createElement(
    reactAriaComponents.ModalContext.Provider,
    { value: contextValue },
    React__default.default.createElement(
      reactAriaComponents.ModalOverlay,
      { className: styles.modalOverlay, "data-zds": true, isOpen, isKeyboardDismissDisabled: !isDismissable, onOpenChange },
      React__default.default.createElement(
        reactAriaComponents.Modal,
        { className: clsx__default.default(className, styles.modal), "data-zds": true },
        React__default.default.createElement(ModalDialogInner, { "aria-label": props["aria-label"], "aria-labelledby": props["aria-labelledby"] }, children)
      )
    )
  );
};
const ModalDialogInner = (_a) => {
  var { children } = _a, props = tslib_es6.__rest(_a, ["children"]);
  const state = React.useContext(reactAriaComponents.OverlayTriggerStateContext);
  const close = React__default.default.useCallback(() => state === null || state === void 0 ? void 0 : state.close(), [state]);
  const modalContext = React.useContext(reactAriaComponents.ModalContext);
  return React__default.default.createElement(
    reactAriaComponents.Dialog,
    { "aria-label": props["aria-label"], "aria-labelledby": props["aria-labelledby"], className: styles.dialog, "data-zds": true },
    (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isDismissable) && React__default.default.createElement(IconButton_IconButton.IconButton, { className: styles.closeButton, name: "formX", onPress: close, variant: "ghost" }),
    typeof children === "function" ? children({ close }) : children
  );
};
const ModalDialog = {
  /**
   * The dialog's main content.
   */
  Body: ModalDialog_Body.ModalDialogBody,
  /**
   * The dialog footer, which should contain up to two buttons:
   * - an optional secondary button
   * - an required primary button
   */
  Footer: ModalDialog_Footer.ModalDialogFooter,
  /**
   * The dialog header containing a descriptive title of the dialog content.
   */
  Header: ModalDialog_Header.ModalDialogHeader,
  /**
   * A modal dialog shown above other content in an application.
   */
  Root: ModalDialogRoot,
  /**
   * A trigger container that listens for a button press to open the modal dialog. It should wrap around a `design-system-beta` `Button` and `Modal.Root`.
   *
   * **Should only be used when the `ModalDialog`'s open state is uncontrolled**
   */
  Trigger: ModalDialog_Trigger.ModalDialogTrigger
};

exports.ModalDialog = ModalDialog;
exports.ModalDialogRoot = ModalDialogRoot;
exports.default = ModalDialog;
//# sourceMappingURL=ModalDialog.cjs.js.map
